import Alpine from "alpinejs";

export default new class Global {
    constructor() {
        this.device();
    }

    device() {
        document.addEventListener('alpine:init', () => {
            Alpine.data('device', () => ({
                isMobile: window.innerWidth < 768,
             
                init() {
                    Alpine.effect(() => {
                        window.addEventListener('resize', () => {
                            this.isMobile = window.innerWidth < 768;
                        });
                    });
                }
            }));
        });
    }
}